<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-07 16:40:29
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 14:51:00
 -->
<template>
  <div class="totalStatics">
    <div class="left">
      <img src="/static/img/layout/protect.png" alt="">
      <div class="protectMileage">安全守护里程：<span class="value">{{eventCumulativeData.mileageTotal}}</span> km</div>
    </div>
    <div class="center">
      <div class="title">累计监测碰撞事件</div>
      <div class="eventNum">{{eventCumulativeData.eventTotal}}</div>
    </div>
    <div class="right">
      <img src="/static/img/layout/road.png" alt="">
      <div class="addMileage">本月新增里程数：<span class="value">{{eventCumulativeData.mileageMonth}}</span> km</div>
      <div class="compare">
        <div class="item">
          同比 <span :class="eventCumulativeData.yearOnYear >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></span> {{eventCumulativeData.yearOnYear}}%
        </div>
        <div class="item">
          环比 <span :class="eventCumulativeData.monthOnMonth >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></span> {{eventCumulativeData.monthOnMonth}}%
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'totalStatics',
  components: {
  },
  data () {
    return {
      eventCumulativeData: {},
    }
  },
  methods: {
    /**
     * @description                   获取累计监测碰撞事件数据
     * @return {undefied}             无返回值
     */
    getEventCumulativeData () {
      this.$http.get('/rest/screen/hlpz/right-top/summary')
        .then(res => {
          if (res.code === 0) {
            this.eventCumulativeData = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getEventCumulativeData()
  },
}
</script>

<style lang="less" scoped>
  .totalStatics {
    width: 100%;
    height: 100%;
    display: inline-flex;
    justify-content: space-around;
    align-items: center;
    >div {
      display: inline-block;
    }
    .left {
      width: 25%;
      text-align: center;
      >img {
        height: 70px;
      }
      .protectMileage {
        width: 100%;
        height: 60px;
        background: url('/static/img/layout/overviewProductBg.png');
        background-size: 100% 100%;
        line-height: 57px;
        font-size: 18px;
        color: #d8d8d8;
        margin-top: 10px;
        .value {
          font-size: 26px;
          color: #00fcf0;
          font-weight: bold;
        }
      }
    }
    .center {
      width: 25%;
      text-align: center;
      .title {
        font-size: 26px;
        color: #ededed;
      }
      .eventNum {
        font-size: 80px;
        font-weight: bold;
        color: #fff;
        text-shadow: 0 0 2vh rgb(5, 239, 252);
        line-height: 10vh;
      }
    }
    .right {
      width: 25%;
      text-align: center;
      position: relative;
      >img {
        height: 70px;
      }
      .addMileage {
        width: 100%;
        height: 60px;
        background: url('/static/img/layout/overviewProductBg.png');
        background-size: 100% 100%;
        font-size: 18px;
        color: #d8d8d8;
        margin-top: 10px;
        line-height: 30px;
        .value {
          font-size: 26px;
          color: #00fcf0;
          font-weight: bold;
        }
      }
      .compare {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 10px;
        .item {
          text-align: center;
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-right: 16px;
          .el-icon-top {
            color: #d92626;
            font-weight: bold;
            font-size: 18px;
          }
          .el-icon-bottom {
            color: #16c840;
            font-weight: bold;
            font-size: 18px;
          }
        }
      }
    }
  }
</style>
